import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonSvg } from '../Svg';
import { chameleonIconBadge, chameleonIconBadgeV2 } from './IconBadge.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonIconBadge({ prefix }), chameleonIconBadgeV2({ prefix }), chameleonSvg({ prefix }));
}
